import "./Home.scss";

import Home from "./Home";

export default Home;
